import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssessmentCountReportRoutingModule } from './assessment-count-report-routing.module';
import {CalendarModule} from 'primeng/calendar';
import{FormsModule} from '@angular/forms'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AssessmentCountReportRoutingModule,CalendarModule,FormsModule
  ]
})
export class AssessmentCountReportModule { }
